<template>
  <div class="inline-block cursor-pointer inline-block">
    <div class="flex items-center h-6 rounded-full bg-blue-100 text-blue pr-3">
      <div class="bg-blue text-white w-6 h-6 rounded-full mr-1 flex items-center justify-center">
        <slot name="icon" />
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Chip'
};
</script>
